exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.finish-text {\n    font-size: 14px;\n}\n.ctis-finished-notice {\n    margin-bottom: 46px;\n}\n", ""]);

// exports
